import { createContext } from 'react'

import type { User } from '../api/types'

export type UserContextType = {
  user: User | null
  loading: boolean
  refreshUser: () => Promise<void>
}

export const UserContext = createContext<UserContextType | undefined>(undefined)